(function () { 
 return angular.module("app")
.constant("config", {"version":{"name":"GeoWorks","company":"GeoStruct B.V.","copyright":"Copyright 2019","version":"2.29"}});

})();
